import type { CourseModule } from "@/core/types";
import { lektionUmbrueche } from "./lektion-01-umbrueche";
import { lektionKopfFusszeile } from "./lektion-02-kopf-fusszeile";
import { lektionSeitenzahlen } from "./lektion-03-seitenzahlen";
import { lektionSeitenraender } from "./lektion-04-seitenraender";
import { lektionSeitenlayoutAbschluss } from "./lektion-05-abschluss";

export const modulSeitenlayout: CourseModule = {
  id: "seitenlayout",
  title: "Seitenlayout, Kopf- und Fußzeilen",
  summary:
    "Die dritte Formatierungsebene: Umbrüche, Ränder, Kopf- und Fußzeilen – " +
    "damit aus dem Text ein abgabefertiges Dokument wird.",
  level: "Grundlagen",
  lessons: [
    lektionUmbrueche,
    lektionKopfFusszeile,
    lektionSeitenzahlen,
    lektionSeitenraender,
    lektionSeitenlayoutAbschluss,
  ],
};
